import { toImmutable, setListInState } from './hooks';
import Session from './session-record';

export default app => {
  const service = app.service('api/sessions');

  service.hooks({
    after: {
      find: [toImmutable(Session, 'account_id'), setListInState('sessions')]
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/sessions.js